import { FlexContainer, Icon, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { parsePriceFormat } from 'Containers/Result/components/PaymentLater/utils';
import { TAXDOWN_ASSETS_DOMAIN } from 'Constants/domains';
import { PreviousYearsPercentage } from 'Types/common';
import * as Styled from './styles';

export const UpsellingAAnfo = ({ data }: { data: PreviousYearsPercentage }): JSX.Element => {
  const { t } = useTranslation(locizeNS.PY);

  return (
    <Styled.InfoContent direction="column" align="center" gap="dimension_16">
      <FlexContainer align="center" gap="dimension_04">
        <img
          src={`${TAXDOWN_ASSETS_DOMAIN}/plans/smart-filter/v2/expert_logo.svg`}
          alt="live_logo"
        />
        <Text type="headline" size="XS_L_M" color="dark">
          {t(`UpsellingInfo.PreviousYears.title`)}
        </Text>
      </FlexContainer>
      <Text type="paragraphs" size="M_M_S" color="dark" align="center">
        {t(`UpsellingInfo.expert.description`)}
      </Text>
      <Text type="paragraphs" size="M_XL_S" color="dark" align="center">
        {t(`UpsellingInfo.expert.info`)}
      </Text>
      <FlexContainer direction="column" gap="dimension_08" fullWidth>
        <Styled.BulletContainer>
          <Icon icon="TickXS" color="active" />
          <Text type="paragraphs" color="grey" size="S_M_S">
            {t(`UpsellingInfo.expert.Bullet.1`)}
          </Text>
        </Styled.BulletContainer>
        <Styled.BulletContainer>
          <Icon icon="TickXS" color="active" />
          <Text type="paragraphs" color="grey" size="S_M_S">
            {t(`UpsellingInfo.expert.Bullet.2`)}
          </Text>
        </Styled.BulletContainer>
        <Styled.BulletContainer>
          <Icon icon="TickXS" color="active" />
          <Text type="paragraphs" color="grey" size="S_M_S">
            {t(`UpsellingInfo.expert.Bullet.3`)}
          </Text>
        </Styled.BulletContainer>
      </FlexContainer>
      <Styled.PriceContainer direction="column" fullWidth gap="dimension_16">
        <FlexContainer justify="space-between" align="center">
          <Text type="paragraphs" size="S_L_S" color="dark" align="center">
            {t(`UpsellingInfo.expert.plan`)}
          </Text>
          <Text type="paragraphs" size="M_XL_S" color="dark" align="center">
            {parsePriceFormat(data?.discountedPrice ?? 0)}
          </Text>
        </FlexContainer>
      </Styled.PriceContainer>
    </Styled.InfoContent>
  );
};
